var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval43A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 76 42",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M48 14c7.732 0 14 6.268 14 14s-6.268 14-14 14H28c-7.732 0-14-6.268-14-14s6.268-14 14-14h20ZM42.776 3.17A2.5 2.5 0 0 1 45.264.917h5.471a2.5 2.5 0 0 1 2.488 2.253l.529 5.33c.133 1.343-1.02 2.5-2.49 2.5h-6.525c-1.47 0-2.622-1.157-2.49-2.5l.53-5.33Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M44.738 1.833c-.686 0-1.314.356-1.62.919l-.223.408c-.247.453-.848.636-1.342.41-.494-.227-.694-.777-.447-1.23l.222-.408C41.974.748 43.294 0 44.738 0h6.524c1.444 0 2.764.748 3.41 1.932l.222.408c.247.453.047 1.003-.447 1.23-.494.226-1.095.043-1.342-.41l-.222-.408c-.307-.563-.935-.919-1.621-.919h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M22.776 3.17A2.5 2.5 0 0 1 25.264.917h5.471a2.5 2.5 0 0 1 2.488 2.253l.529 5.33c.133 1.343-1.02 2.5-2.49 2.5h-6.525c-1.47 0-2.622-1.157-2.49-2.5l.53-5.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M24.738 1.833c-.686 0-1.314.356-1.62.919l-.223.408c-.247.453-.848.636-1.342.41-.494-.227-.694-.777-.447-1.23l.222-.408C21.974.748 23.294 0 24.738 0h6.524c1.444 0 2.764.748 3.41 1.932l.222.408c.247.453.047 1.003-.447 1.23-.494.226-1.095.043-1.342-.41l-.222-.408c-.307-.563-.935-.919-1.621-.919h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.17 33.224a2.5 2.5 0 0 1-2.253-2.488v-5.471a2.5 2.5 0 0 1 2.253-2.488l5.33-.529c1.343-.133 2.5 1.02 2.5 2.49v6.525c0 1.47-1.157 2.622-2.5 2.49l-5.33-.53Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M1.833 31.262c0 .686.356 1.314.919 1.62l.408.223c.453.247.636.848.41 1.342-.227.494-.777.694-1.23.447l-.408-.222C.748 34.026 0 32.706 0 31.262v-6.524c0-1.444.748-2.764 1.932-3.41l.408-.222c.453-.247 1.003-.047 1.23.447.226.494.043 1.095-.41 1.342l-.408.222c-.563.307-.919.935-.919 1.621v6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M72.83 22.776a2.5 2.5 0 0 1 2.253 2.488v5.471a2.5 2.5 0 0 1-2.253 2.488l-5.33.529c-1.343.133-2.5-1.02-2.5-2.49v-6.525c0-1.47 1.157-2.622 2.5-2.49l5.33.53Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M74.167 24.738c0-.686-.356-1.314-.919-1.62l-.408-.223c-.453-.247-.636-.848-.41-1.342.226-.494.777-.694 1.23-.447l.408.222c1.184.646 1.932 1.966 1.932 3.41v6.524c0 1.444-.748 2.764-1.932 3.41l-.408.222c-.453.247-1.004.047-1.23-.447-.226-.494-.043-1.095.41-1.342l.408-.222c.563-.307.919-.935.919-1.621v-6.524Z",
  clipRule: "evenodd"
})));
SvgOval43A.viewBox = '0 0 76 42';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval43A);
export default ForwardRef;